import axiosInstance from './axiosInstance';

/**
 * Menu Admin Service
 * Handles menu management API calls for admin
 */
const menuAdminService = {
  /**
   * Get all menus with pagination
   * @param {number} page - Page number (default: 1)
   * @param {number} limit - Items per page (default: 10)
   * @param {boolean} is_admin - Filter by is_admin flag (optional)
   * @returns {Promise}
   */
  getAllMenus: async (page = 1, limit = 10, is_admin = null) => {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      if (is_admin !== null) {
        params.append('is_admin', is_admin);
      }

      const response = await axiosInstance.get(`/admin/menus?${params.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Get menu by ID
   * @param {number} id - Menu ID
   * @returns {Promise}
   */
  getMenuById: async (id) => {
    try {
      const response = await axiosInstance.get(`/admin/menus/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Create new menu
   * @param {object} menuData - Menu data { name, code, is_admin }
   * @returns {Promise}
   */
  createMenu: async (menuData) => {
    try {
      const response = await axiosInstance.post('/admin/menus', menuData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Update menu
   * @param {number} id - Menu ID
   * @param {object} menuData - Menu data to update
   * @returns {Promise}
   */
  updateMenu: async (id, menuData) => {
    try {
      const response = await axiosInstance.put(`/admin/menus/${id}`, menuData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Delete menu
   * @param {number} id - Menu ID
   * @returns {Promise}
   */
  deleteMenu: async (id) => {
    try {
      const response = await axiosInstance.delete(`/admin/menus/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default menuAdminService;
